import { Link } from "react-router-dom";
import { Calculator, Scale, Percent, ArrowRight } from "lucide-react";

const ICONS = {
  "airbnb-deal-analyser": Calculator,
  "long-let-vs-short-let-calculator": Scale,
  "short-let-yield-calculator": Percent,
};

export default function ToolsSection({ tools }) {
  return (
    <section id="tools" style={{ backgroundColor: "#fff", padding: "clamp(48px, 6vw, 80px) clamp(20px, 5vw, 80px)", scrollMarginTop: 68 }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ marginBottom: 32 }}>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#888", marginBottom: 8, marginTop: 0 }}>Tools & Calculators</p>
          <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(24px, 3vw, 34px)", letterSpacing: "-0.02em", color: "#1A1A1A", margin: "0 0 10px" }}>Free tools to crunch the numbers</h2>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#666", lineHeight: 1.6, margin: 0, maxWidth: 560 }}>Real, working calculators — see what your property could earn, compare models and work out your yield.</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 24 }} className="tools-grid">
          {tools.map((t) => {
            const Icon = ICONS[t.slug] || Calculator;
            return (
              <Link
                key={t.slug}
                to={`/resources/tools/${t.slug}`}
                style={{ textDecoration: "none", background: "#fff", border: "1px solid #EBEBEB", borderRadius: 16, padding: 28, display: "flex", flexDirection: "column", transition: "transform 0.2s, box-shadow 0.2s, border-color 0.2s" }}
                onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 32px rgba(0,0,0,0.1)"; e.currentTarget.style.borderColor = "#DDD"; }}
                onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.borderColor = "#EBEBEB"; }}
              >
                <div style={{ width: 44, height: 44, borderRadius: 12, background: "#E8EDFF", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 18 }}>
                  <Icon size={20} color="#4A6DC7" />
                </div>
                <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#888", marginBottom: 8, display: "block" }}>{t.tag}</span>
                <h3 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 18, color: "#1A1A1A", margin: "0 0 8px", lineHeight: 1.3, letterSpacing: "-0.01em" }}>{t.title}</h3>
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#666", lineHeight: 1.6, margin: "0 0 20px", flex: 1 }}>{t.desc}</p>
                <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, fontWeight: 600, color: "#1A1A1A", display: "inline-flex", alignItems: "center", gap: 6 }}>Open tool <ArrowRight size={15} /></span>
              </Link>
            );
          })}
        </div>
      </div>
      <style>{`@media (max-width: 768px) { .tools-grid { grid-template-columns: 1fr !important; } }`}</style>
    </section>
  );
}